export default {
  CONFIRMATION_KEY: "is_change_school",
} as const;
